<template>
  <div class="page-background">
    <Modal v-if="isShow" />
    <div class="flex-row flex-spbt">
      <h2>{{ $t('SAAI.SetFeedback.title') }}</h2>
      <ProgressBar />
    </div>
    <div v-for="sheet in this.numberOfSheets" :key="sheet" class="page-container flex-row">
      <AnalysisResult v-if="nowSheetNumber === sheet - 1" />
    </div>
  </div>
</template>

<script>
import Modal from '@/components/Modal.vue';
import AnalysisResult from '@/components/Saai/SetFeedbackPage/AnalysisResult.vue';
import { mapActions, mapState } from 'vuex';
import ProgressBar from '@/components/Saai/WordSetting/ProgressBar.vue';

export default {
  name: 'SetFeedback',
  components: {
    Modal,
    AnalysisResult,
    ProgressBar,
  },
  data() {
    return {
      sheetNumber: 0,
    };
  },
  methods: {
    ...mapActions('modal', ['AC_MODAL_OPEN']),
  },
  computed: {
    ...mapState('modal', ['isShow', 'modalContent', 'modalUrl']),
    ...mapState('saaiPaper', {
      numberOfSheets: (state) => state.numberOfSheets,
      nowSheetNumber: (state) => state.nowSheetNumber,
    }),
    // ...mapState('login', ['isLogin']),
  },
  created() {
    const currentRoutePath = JSON.parse(localStorage.getItem('currentRoutePath'));
    if (currentRoutePath === '/saai/setFeedback' && currentRoutePath !== '/saai/wordSetting') {
      localStorage.removeItem('currentRoutePath');
      this.$router.push('/saai/create');
      return;
    }
  },
  beforeRouteLeave(to, from, next) {
    let confirmText = '데이터가 손실될 수 있습니다. 계속 진행하시겠습니까?';
    if (to.path === '/saai/wordSetting' && !confirm(confirmText)) {
      next(false);
    } else {
      next();
    }
  },
};
</script>

<style lang="scss" scoped>
.page-background {
  height: 100%;
}
</style>
